import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { Vehicle } from '@classes/vehicles/vehicle';
import { VehiclesService } from '@services/vehicles/vehicles.service';


@Injectable()
export class VehiclesResolver {
    constructor(
        private vehiclesSrv: VehiclesService,
        private uiSrv: UiService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Vehicle[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.vehiclesSrv.getList()
            .pipe(
                tap(() => {
                    this.uiSrv.routeLoadingStateChanged.next(false);
                })
            );
    }
}
